import { render, staticRenderFns } from "./SaasDashboardView.vue?vue&type=template&id=600ca216&scoped=true&"
import script from "./SaasDashboardView.vue?vue&type=script&lang=js&"
export * from "./SaasDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./SaasDashboardView.vue?vue&type=style&index=0&id=600ca216&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ca216",
  null
  
)

export default component.exports